import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import { BsModalRef } from "ngx-bootstrap/modal";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { PartyService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./addEditParty.html",
})
export class AddEditParty {
  @Output() partyUpdateEvent = new EventEmitter();
  row: any;
  data: any;
  qualityList: any;
  typeList: any;
  lineLists: any;
  party_type: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  history_data = {}
  partyTypeList = ["SALES PARTY", "PURCHASE PARTY"];
  teamList = ["PREMIUM", "PRIME"];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  mode: string;
  saveEvent: any;
  agentList: any;
  purchaseAgentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  statusList = [{ name: "ACTIVE" }, { name: "INACTIVE" }];
  boxlessList = [{ name: "YES" }, { name: "NO" }];
  packStyleList = ['BOX', 'W/O BOX'];

  @Input() partydata: any = {
    party_code: "",
    name: "",
    designation: "",
    address: "",
    city: "",
    state: "",
    phone1: "",
    mobile1: "",
    email: "",
    doj: "",
    agent_name: "",
    agent_id: "",
    party_type: "",
    boxless: "",
    status: "",
    gst_no: "",
    reason: "",
    inactive_date: "",
    grade: "",
    payment_avg: "",
    discount: 0,
    act_discount: 0,
    special_discount: 0,
    discapp : "",
    line: "",
    purchase_agent: "",
    purchase_agent_id : 0,
    pack_style : "",
    formal: false,
    casual: false,
    sv: false,
    inv_reflect: false
  };
  @ViewChild("agentAuto") agentAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  statusCtrl: FormControl = new FormControl();
  lineCtrl: FormControl = new FormControl();
  inchargeCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  mobilenoCtrl: FormControl = new FormControl();
  boxlessCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private partyService: PartyService
  ) {}


 
  ngOnInit() {
    if (this.mode == "Add") {
      this.partydata.join_date = this.datePipe.transform(
        new Date(),
        "yyyy-mm-dd"
      );
      this.partydata.inactive_date = this.datePipe.transform(
        new Date(),
        "yyyy-mm-dd"
      );
      //  this.partydata.status = 'ACTIVE';
    }



 

    setTimeout(() => {
      if (this.partydata.mode != 'Add' && this.partydata.party_type == 'SALES PARTY') {
        this.partydata.prev_agent_id = this.partydata.agent_id;
        this.partydata.prev_name = this.partydata.name;
        this.partydata.formal = Boolean(Number(this.partydata.formal));
        this.partydata.casual = Boolean(Number(this.partydata.casual));
        this.partydata.sv = Boolean(Number(this.partydata.sv));
        this.partydata.inv_reflect = Boolean(Number(this.partydata.inv_reflect));
        console.log("check party Detailsssss", this.partydata, this.mode)
      }
    
    }, 500);

    this.getAgentList();
    this.getPurchaseAgentList();
    this.lineList();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#code").focus();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else if (nextEl == "partySave") {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      // this.save();
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }
  lineList() {
    let that = this;
    that.partyService.getLineList({}).then((res: any) => {
      that.lineLists = res;
      //  that.agentCtrl.setValue(this.partydata['agent_name']);
    });
  }

  getAgentList() {
    let that = this;
    that.partyService.getAgentList({}).then((res: any) => {
      that.agentList = res;
      that.agentCtrl.setValue(that.partydata["agent_name"]);
      if (that.mode == "Edit" || that.mode == "View") {
        let partylist = _.filter(that.agentList, {
          genLedid: that.partydata.agent_id,
        });
        that.partydata.agent_name = partylist[0]["name"];
      }
    });
  }

  getPurchaseAgentList() {
    let that = this;
    that.partyService.getPurchaseAgentList({}).then((res: any) => {
      that.purchaseAgentList = res;
    });
  }
  getTotdisc(){

    this.partydata.discount = Number(this.partydata.act_discount) + Number(this.partydata.special_discount)

    if(this.partydata.discapp == 'NO'){
      this.partydata.discount = 5;
    }
  }
  onPackStyleChange(value: string) {


    if (this.mode != 'Add') return;

    const isWOBox = value === 'W/O BOX';
    this.partydata.formal = this.partydata.casual = this.partydata.sv = isWOBox;

    console.log("check data", this.partydata, this.partydata, this.mode)

  }
  saveParty() {
    if (
      !this.partydata.name ||
      !this.partydata.party_code 
    ) {
      swal("Enter all the required fields");
    }

    let that = this;
    let temp: any = {};
    temp.party_name = this.partydata.name;
    temp.code = this.partydata.party_code;
    temp.address = this.partydata.address;
    temp.phone = this.partydata.phone1;
    temp.city = this.partydata.city;
    temp.state = this.partydata.state;
    temp.district = this.partydata.district;
    temp.status = this.partydata.status;
    temp.pin = this.partydata.pin;
    temp.gst_no = this.partydata.gst_no;
    temp.act_discount = this.partydata.act_discount;
    temp.special_discount = this.partydata.special_discount;
    temp.discount = this.partydata.discount;
    temp.discapp = this.partydata.discapp;
    temp.grade = this.partydata.grade;
    temp.reason = this.partydata.reason;
    temp.payment_avg = this.partydata.payment_avg;
    temp.purchase_agent = this.partydata.purchase_agent;
    temp.purchase_agent_id = this.partydata.purchase_agent_id;
    // temp.boxless = this.partydata.boxless;
    if (this.partydata.party_id !== undefined) {
      temp.party_id = this.partydata.party_id;
    }
    // else if (this.partydata.discapp == "NO") {
    //   temp.discapp = 0;
    // }
    //   temp.state = this.partydata.state;
    let params = Object.assign({}, temp);
    that.isLoading = true;
    that.partyService
      .saveParty(params)
      .then(function (res: any) {
        that.isLoading = false;
        if (res.success) {
          that.partydata = {
            code: "",
            name: "",
            designation: "",
            address: "",
            city: "",
            state: "",
            phone: "",
            mobile: "",
            email: "",
            doj: "",
            agent: "",
            status: "",
            boxless: "",
            gst_no: "",
            grade: "",
            inactive_date: "",
            reason: "",
            payment_avg: 0,
            discount: 0,
            act_discount: 0,
            special_discount: 0,
            discapp : "",
            purchase_agent: "",
            purchase_agent_id : 0
          };

          that.bsModalRef.hide();
          //      that.partyUpdateEvent.emit();
          that.toasterService.pop({
            bodyOutputType: 1,
            type: "success",
            title: "SUCCESS",
            body: res.message,
          });
        } else {
          swal("ERROR", res.message, "error");
        }
      })
      .catch(function (error: any) {
        that.isLoading = false;
        let res = JSON.parse(error._body);
        swal("ERROR", res.message, "error");
        //console.log(error);
      });
  }
  save() {
    let line_id = this.lineLists.filter((el) => {
      return el.line == this.partydata.line;
    });

    if (line_id.length == 0) {
      this.partydata.line = "";
      swal("PLEASE SELECT VALID LINE");
      return false;
    }

    if (
      !this.partydata.name ||
      !this.partydata.status == undefined ||
      !this.partydata.party_code ||
      this.partydata.agent_id == "0" || !this.partydata.pack_style ||
      (this.partydata.discapp == 'YES' && this.partydata.discount == 0)
    ) {
      swal("Enter all the required fields");
    } else {
      let that = this;
      let params = Object.assign({}, this.partydata);
      if (this.partydata.agent_name == "") {
        params["agent_id"] = "";
      }
      params["taxper"] = "";
      params["contactName"] = "";
      params["phone2"] = "";
      params["mobile2"] = "";
      params["phone1"] = params["phone1"] == "" ? "" : params["phone1"];
      params["mobile1"] = params["mobile1"] == "" ? "" : params["mobile1"];
      params["dis_days"] = params["dis_days"] == "" ? "" : params["dis_days"];
      params["agent_dis_deduct"] = params["agent_dis_deduct"] == "" ? "" : params["agent_dis_deduct"];
      params["tinno"] = "";
      params["website"] = "";
      params["cstno"] = "";
      params["taxno"] = "";
      params["panno"] = "";
      params["tanno"] = "";
      params["cin"] = "";
      params["isagent"] = "NO";
      params["pin"] = params["pin"] == "" ? "" : params["pin"];
      params["agent_type"] = "";
      params["city"] = params["city"] == "" ? "" : params["city"];
      params["state"] = params["state"] == "" ? "" : params["state"];
      params["join_date"] = that.datePipe.transform(
        that.partydata.join_date,
        "yyyy-MM-dd"
      );
      params["inactive_date"] = that.datePipe.transform(
        that.partydata.inactive_date,
        "yyyy-MM-dd"
      );
      params["line_id"] = line_id[0]["line_id"];

      that.isLoading = true;
      that.partyService
        .save(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (res.success) {
            that.partydata = {
              code: "",
              name: "",
              designation: "",
              address: "",
              city: "",
              state: "",
              phone: "",
              mobile: "",
              email: "",
              doj: "",
              agent: "",
              status: "",
              boxless: "",
              gst_no: "",
              discount: 0,
              act_discount: 0,
              special_discount: 0,
              discapp : "",
              line: "",
            };

            that.bsModalRef.hide();
            that.partyUpdateEvent.emit();
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    }
  }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }
    if (this.agentList.length > 0) {
      if (id && list.length > 0) {
        let fitem = _.find(list, { name: id });
        this.partydata.agent_name = fitem["name"];
        this.partydata.agent_id = fitem["genLedid"];
        return fitem["name"];
      }
    }

    return "";
  }
  onSelectAgentName(agent_name) {
    let fitem = _.find(this.agentList, { name: agent_name });
    this.partydata.agent_name = fitem["name"];
    this.partydata.agent_id = fitem["genLedid"];
  }

  onSelectPurchaseAgentName(agent_name) {
    let fitem = _.find(this.purchaseAgentList, { agent_name : agent_name });
    this.partydata.purchase_agent = fitem["agent_name"];
    this.partydata.purchase_agent_id = fitem["agent_id"];
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/party/addEditParty.ts